import { Avatar, Badge, Button } from '@mela/design-system';

export function HeroIdCard() {
  return (
    <div
      className="bg-white border border-ink-200 rounded-xl p-6 shadow-floating w-[360px] max-w-[calc(100vw-3rem)] relative z-[3] animate-hero-float"
      role="figure"
      aria-label="Sample Mela ID card"
    >
      <div className="flex gap-3 items-start">
        <Avatar size="lg" initials="SP" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap mb-0.5">
            <strong className="text-base font-bold text-ink-900 -tracking-[0.01em]">
              Sneha Patel
            </strong>
            <Badge variant="verified">★ Verified</Badge>
          </div>
          <div className="text-[13px] text-ink-600 mb-0.5">Director · Patel Textiles</div>
          <div className="font-mono text-[12px] text-ink-500">@snehapatel · Surat</div>
        </div>
      </div>

      <div className="h-px bg-ink-200 my-3.5" />

      <div className="font-mono text-[10px] tracking-wider uppercase text-ink-500 mb-1.5">
        Currently selling
      </div>
      <p className="font-display text-[15px] leading-[1.4] text-ink-800 font-medium mb-3.5">
        “Premium cotton blends for export to MENA. MOQ 500 units, ready in 14 days.”
      </p>

      <div className="flex gap-1 flex-wrap mb-4">
        {['Textiles', 'Exports', 'Gujarat'].map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 bg-bg-soft text-ink-700 border border-ink-200 rounded-sm text-[11px] font-medium"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="flex gap-1.5">
        <Button variant="outline" size="sm" className="flex-1">
          Message
        </Button>
        <Button variant="primary" size="sm" className="flex-1">
          Save to Mela
        </Button>
      </div>
    </div>
  );
}

export function GhostIdCard({ className }: { className?: string }) {
  return (
    <div
      className={`hidden lg:block w-[280px] h-[200px] bg-white border border-ink-200 rounded-xl shadow-elevated z-[1] absolute ${
        className ?? ''
      }`}
      aria-hidden="true"
    >
      <div className="absolute top-4 left-4 w-8 h-8 rounded-full bg-violet-100" />
      <div className="absolute top-6 left-[60px] flex flex-col gap-2">
        <div className="w-[100px] h-2 rounded bg-ink-200" />
        <div className="w-[80px] h-2 rounded bg-ink-100" />
        <div className="w-[60px] h-2 rounded bg-ink-100" />
      </div>
    </div>
  );
}
